import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'
import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'
import lang from '@/lang'
import Loader from '@/modules/base/components/loader/loader'
import TextBlock from '@/modules/base/components/texts/text-block'
import LetterPaperLayoutList from './list/letter-paper-layout-list'
import LetterPaperLayoutThumbnail from './letter-paper-layout-thumbnail'
import { toast } from '@/modules/base/components/toast/toastConfig'

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
  },
  list: {
    flexBasis: '50%',
  },
  thumbnail: {
    display: 'grid',
    justifyContent: 'stretched',
    flexGrow: 1,
  },
}))

const LetterPaperLayout = forwardRef((props, ref) => {
  // set standard badge should be removed after refactoring of this component
  // component should not have individual set standard button but one save button
  const { letterPaperSettings, setSelectedLayoutId, setThumbnailLayoutItems, isOnboardingTester = false } = props
  const [items, setItems] = useState()
  const [id, setId] = useState()
  const [defaultId, setDefaultId] = useState()
  const classes = useStyles()
  const { isLoading } = useSelector(store => store.settings.letterPaper)
  useImperativeHandle(ref, () => ({
    saveSelectedDefault: () => {
      return onSetDefault(id)
    },
  }))

  useEffect(() => {
    request(settingsConfig.getLetterPaperLayout, {
      method: 'GET',
      auth: true,
      isConcurrent: true,
    })
      .then((result) => {
        const { body: { data } } = result
        setItems(data)
        setThumbnailLayoutItems(data)
        setId(letterPaperSettings?.letterPaperLayoutId)
        setDefaultId(letterPaperSettings?.letterPaperLayoutId)
      })
  }, [letterPaperSettings])

  useEffect(() => {
    setSelectedLayoutId(id)
  }, [id])

  const onSetDefault = (id) => {
    return request(settingsConfig.createLetterPaper, {
      auth: true,
      method: 'POST',
      data: { letterPaperLayoutId: id },
    })
      .then((response) => {
        toast.showToast({ message: lang.settings.letterPaperSettings.layout.updateSuccessMessage })
        const { body: { data: { letterPaperLayoutId } } } = response
        setId(letterPaperLayoutId)
        setDefaultId(letterPaperLayoutId)
      }).catch(() => {
        toast.showToast({ type: 'error', message: lang.settings.letterPaperSettings.layout.updateErrorMessage })
      })
  }

  return (
    <div>
      {isLoading && <Loader text={lang.generics.isLoadingWithTitle(lang.settings.pageTitles.letterPaper)} /> }
      {!isOnboardingTester && <TextBlock>{lang.settings.letterPaperSettings.layout.description}</TextBlock> }
      <div className={classes.content}>
        <div className={classes.list}>
          <LetterPaperLayoutList
            data={items}
            defaultId={defaultId}
            selectedItemId={id}
            setSelectedItemId={setId}
            onSetDefault={onSetDefault}
            isOnboardingTester={isOnboardingTester}
          />
        </div>
        <div className={classes.thumbnail}>
          <LetterPaperLayoutThumbnail thumbnailItems={items} letterPaperLayoutId={id} />
        </div>
      </div>
    </div>
  )
})

export default LetterPaperLayout
